document.addEventListener('DOMContentLoaded', function (dom) {
    const containerServices = dom.target.querySelector('.container__services');
    if (containerServices) {
        const feedServices = containerServices.querySelectorAll('.feed-service');
        if (feedServices.length) {
            feedServices.forEach(service => {
                service.addEventListener('mouseenter', () => {
                    containerServices.classList.add('has-hover')
                    service.classList.add('is-hovered');
                });

                service.addEventListener('mouseleave', () => {
                    containerServices.classList.remove('has-hover')
                    service.classList.remove('is-hovered');
                });
            });
        }
    }
});
